import { GOOGLE_ANALYTICS_TO_SPLIT, SPLIT_TO_GOOGLE_ANALYTICS } from '@splitsoftware/splitio-commons/esm/utils/constants/browser';
import { validateConfigurableIntegrations } from '@splitsoftware/splitio-commons/esm/utils/settingsValidation/integrations/configurable';
export function validateIntegrations(settings) {
    return validateConfigurableIntegrations(settings, [GOOGLE_ANALYTICS_TO_SPLIT, SPLIT_TO_GOOGLE_ANALYTICS]);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/settings/integrations/browser.js
// module id = 3849
// module chunks = 25